<template>
  <b-row>
    <b-col cols="12">
      <!-- Period -->
      <b-row>
        <b-col cols="4" lg="3" class="d-flex align-items-center">
          <p class="mr-1 mb-0 font-weight-bold">Period:</p>
          <b-form-select v-model="period" :options="periodOptions" />
        </b-col>
        <b-col cols="1" lg="3"></b-col>
        <!-- From / To -->
        <b-col
          cols="7"
          md="6"
          class="w-100 d-flex align-items-center"
          style="gap: 12px"
        >
          <flat-pickr v-model="from" class="bg-white" :config="configDate" />
          <span>to</span>
          <flat-pickr v-model="to" class="bg-white" :config="configDate" />
          <b-button variant="primary" @click="handleSelectRange"
            >Apply</b-button
          >
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12" class="mt-2">
      <div
        v-if="loading"
        class="d-flex align-items-center justify-content-center"
      >
        <Spinner variant="primary" class="mx-auto mb-2" size="medium" />
      </div>
      <DashboardStatistic
        v-else
        :statistics="statistics"
        :racingOverview="racingOverview"
        :sportOverview="sportOverview"
    /></b-col>
    <b-col cols="12" md="6"
      ><TopRanking :users="tables.top10Losers" :loading="loading"
    /></b-col>
    <b-col cols="12" md="6"
      ><TopRanking :users="tables.top10Winners" is-winner :loading="loading"
    /></b-col>
  </b-row>
</template>

<script>
import { BCol, BRow, BFormSelect, BCard, BButton } from "bootstrap-vue";
import DashboardStatistic from "./DashboardStatistic.vue";
import TopRanking from "./top-ranking";
import { mapState, mapActions } from "vuex";
import flatPickr from "vue-flatpickr-component";
import Spinner from "@core/components/Spinner";

export default {
  components: {
    BRow,
    BCol,
    BFormSelect,
    BCard,
    BButton,
    DashboardStatistic,
    TopRanking,
    flatPickr,
    Spinner,
  },
  data() {
    const periodOptions = [
      { text: "This Month", value: "this_month" },
      { text: "Today", value: "today" },
      { text: "Last 7 days", value: "last_7_days" },
      { text: "Last 30 days", value: "last_30_days" },
      { text: "Last 90 days", value: "last_90_days" },
    ];
    return {
      statistics: {
        turnover: {
          value: 0,
          realValue: 0,
          bonusValue: 0,
          vsLastPeriodPct: 0,
          splitResultedPct: 0,
          splitUnresultedPct: 0,
        },
        ggr: {
          value: 0,
          vsLastPeriodPct: 0,
        },
        ngr: {
          value: 0,
          vsLastPeriodPct: 0,
        },
        cashInBank: {
          value: 0,
          deltaTodayPct: 0,
        },
        ggrSplitBonusVsCash: {
          bonusPct: 0,
          cashPct: 0,
          marginOnCashHigherByPp: 0,
        },
        betSplitRacingVsSport: {
          racingPct: 0,
          sportPct: 0,
        },
        betTypeSplit: {
          singlePct: 0,
          multiPct: 0,
          exoticPct: 0,
        },
        activeClients: {
          value: 0,
          vsLastPeriodPct: 0,
        },
        newSignupsThisMonth: {
          value: 0,
          vsLastPeriodPct: 0,
        },
        closedAccounts: {
          count: 0,
          label: "This period",
        },
        unsettledBets: {
          count: 0,
        },
        betstop: {
          count: 0,
          label: "This period",
        },
        affiliateNgrPayouts: {
          value: 0,
          label: "Month-to-date",
        },
        ytdRevenue: {
          value: 0,
          budget: 0,
          variancePct: 0,
        },
        ytdTurnover: {
          value: 0,
          budget: 0,
          variancePct: 0,
        },
        ytdYield: {
          value: 0,
          budget: 0,
          variancePct: 0,
        },
        wtdRevenue: {
          value: 0,
          budget: 0,
          variancePct: 0,
        },
        wtdTurnover: {
          value: 0,
          budget: 0,
          variancePct: 0,
        },
        wtdYield: {
          value: 0,
          budget: 0,
          variancePct: 0,
        },
      },
      losers: [],
      winners: [],
      racingOverview: {
        settledTotalBets: 0,
        settledBets: 0,
        settledBonusBets: 0,
        rejectedBets: 0,
        unsettledBets: 0,
        unsettledBonusBets: 0,
        unsettledAmount: 0,
        unsettledBonusAmount: 0,
        betsStake: 0,
        bonusResult: 0,
      },
      sportOverview: {
        settledTotalBets: 0,
        settledBets: 0,
        settledBonusBets: 0,
        rejectedBets: 0,
        unsettledBets: 0,
        unsettledBonusBets: 0,
        unsettledAmount: 0,
        unsettledBonusAmount: 0,
        betsStake: 0,
        bonusResult: 0,
      },
      configDate: {
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },

      period: periodOptions[0].value,
      from: null,
      to: null,
      periodOptions,
    };
  },
  computed: {
    ...mapState("dashboard/detail", {
      tables: "tables",
      charts: "charts",
      loading: "loading",
    }),
    ...mapState("auth", ["user"]),
  },
  watch: {
    period(val) {
      this.from = null;
      this.to = null;
      this.fetchDataDashboard();
    },
    charts(val) {
      if (val) {
        this.statistics = val.card;
        this.racingOverview = val.racingOverview;
        this.sportOverview = val.sportOverview;
      }
    },
  },
  async created() {
    await this.fetchDataDashboard();
  },
  methods: {
    ...mapActions("dashboard/detail", {
      getDataDashboard: "getDataDashboard",
    }),
    fetchDataDashboard() {
      const { from, to, period } = this;
      const payload = from && to
        ? { dateFrom: from, dateTo: to }
        : { timePeriod: period };
      this.getDataDashboard(payload);
    },
    handleSelectRange() {
      if (!this.from || !this.to) return;
      this.fetchDataDashboard();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
